import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import photo from "../assets/img/elize-about.webp";
import instalogo from "../assets/img/logo-insta.png";
import { useLocation } from "react-router-dom";

const About = () => {
  const location = useLocation();

  return (
    <div>
      <Navigation />
      <Helmet>
        <title>ABOUT | ELIZE SOKOLOVA</title>
        <link
          rel="canonical"
          href={`https://www.elizesokolova.com${location.pathname}`}
        />
      </Helmet>

      <div className="wrapper">
        <div className="about-container">
          <div className="about-title">ABOUT</div>
          <div style={{ marginBottom: "30px" }}></div>
          <div className="about-section">
            <div className="about-photo">
              <img src={photo} alt="Elize Sokolova"></img>
              <p style={{ fontSize: "0.8em" }}>© Bri-L Florence Detienne</p>
            </div>

            <div className="about-text">
              <p>
                <strong>Elize Sokolova</strong> (born in France, 1997) lives and
                works in Brussels, Belgium. As a multidisciplinary artist, she
                explores the use of color and symbols, transforming each work
                into a space for dreams and reflection, where the viewer is
                invited to go beyond literal interpretation to access an
                emotional and poetic experience of art.
              </p>
              <br></br>
              <p>—</p>
              <br></br>
              <p>
                Originally from Dunkirk, France, Elize studied photography and
                then graphic design on a work-study program, during which she
                worked as a textile graphic designer in northern France. After
                completing her studies, a trip to Ecuador to do volunteer work
                marked a turning point and revealed her passion for painting.
              </p>
              <br></br>
              <p>
                Her curiosity has driven her to explore various artistic fields
                from a young age. She developed a passion for photography early
                on and quickly became interested in "distorting" reality through
                images, creating graphic compositions, and playing with shapes,
                textures, and colors. Through all her work, whatever the medium,
                she loves inviting viewers into a parallel world, encouraging
                them to dream and go beyond their perception of reality. It is
                with this mindset that she had expanded her practice to include
                painting and sculpture, with no limits to the imagination.
              </p>
              <br></br>
              <p>
                Her figurative universe, nourished by surrealism, is
                characterized by intense colors and symbolic compositions.
                Through metaphorical scenes and figures charged with inner
                tension, she questions psychological states, emotional duality,
                and the link between the body and the inner landscape. Her
                painting lies at the border between reality and imagination,
                using images as a language to translate the intimate, the
                subconscious, and emotional experiences.
              </p>
              <br></br>
              <p>
                <em>
                  Have any questions or requests? Feel free to contact me via{" "}
                  <a href="mailto:elizesokolova@gmail.com">email</a>.
                </em>
              </p>
              <br></br>
              <a
                target="_blank"
                rel="noreferrer"
                href="http://www.instagram.com/elize.sokolova"
              >
                <img
                  src={instalogo}
                  alt="Instagram"
                  width="30"
                  height="30"
                ></img>
              </a>
            </div>
          </div>
          <div className="cv-press-section">
            <div className="cv-section">
              <div className="about-title">CV</div>

              <div className="cv-column">
                <div className="year">2027</div>
                <div className="event">
                  "Twist in our sobriety" duo exhibition w/ Djos Janssens
                </div>
                Flux Gallery - Liège, BE
                <div className="year">2026</div>
                <div className="event">
                  "What to do before the apocalypse?" solo exhibition
                </div>
                Chong gallery - Geneva, SW
                <div className="year">2025</div>
                <div className="event">Creation of a mural</div>
                Ancienne Belgique Concert Hall - Brussels, BE
                <div className="event">«NOCTURNÆ» group exhibition</div>
                Espace Qartier / Bourse station - Brussels, BE
                <div className="event">Creation of a mural</div>
                Ancienne Belgique Concert Hall - Brussels, BE
                <div className="year">2024</div>
                <div className="event">«METAMORPHOSE» group exhibition</div>
                «Qui dit mieux?» competition by Promojeune ASBL - Belgium
                <div className="event">
                  «EXPERIMENTAL VIDEO» group exhibition
                </div>
                Fluxus Museum - Paros, GR
                <div className="event">
                  «BISOUS BISOUS VOL. 2» group exhibition
                </div>
                Les compères gallery - Dunkirk, FR
                <div className="event">Creation of a mural</div>
                Ancienne Belgique Concert Hall - Brussels, BE
                <div className="event">«OPEN CALL» group exhibition</div>
                Chong gallery - Geneva, CH
                <div className="event">«OH Là Là!» group exhibition</div>
                Smack gallery - Lille, FR
                <div className="event">Creation of murals</div>
                Liedts street, Schaerbeek - Brussels, BE
                <div className="event">
                  «BILLBOARDS ACROSS BELGIUM» solo exhibition
                </div>
                Artcrush gallery x Clear channel - Belgium
              </div>

              <div className="cv-column">
                <div className="year">2023</div>
                <div className="event">«MEET MY ARTS» group exhibition</div>
                Parcours d’artistes - Brussels, BE
                <div className="event">«DREAM CATCHING» solo exhibition</div>
                La Librairie Dunkerque, FR
                <div className="event">Group exhibition</div>
                Le réservoir bar - Brussels, BE
                <div className="event">Creation of murals</div>
                Bouaké city and Mon Afrik hostel - Ivory Coast
                <div className="year">2022</div>
                <div className="event">
                  «ISSUE DE SECOURS» group exhibition and winner's prize
                </div>
                «Qui dit mieux?» competition by Promojeune ASBL - Belgium
                <div className="event">Solo painting exhibition</div>
                Braz bar - Lille, FR
                <div className="year">2019</div>
                <div className="event">Creation of murals</div>
                Donki and Coco Bongo hostels - Ecuador
              </div>
            </div>

            <div className="press-section">
              <div className="about-title">PRESS</div>
              <div style={{ marginBottom: "30px" }}></div>

              <a
                target="_blank"
                rel="noreferrer"
                href="https://opaleart.com/portraits-art-contemporain/elize-sokolova/"
              >
                Opale Art
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.bri-l.be/elize"
              >
                BRi-L
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.abconcerts.be/fr/actualites/lartiste-elize-sokolova-transforme-deux-murs-a-lab/a1eQw000002IhbdIAC"
              >
                Ancienne Belgique
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://streetartcities.com/cities/brussels/markers/0a377eb1-5490-4c12-87cb-57deb6871d92"
              >
                Street Art Cities
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.lavoixdunord.fr/1342791/article/2023-06-20/dunkerque-elize-sokolova-expose-dans-la-galerie-de-la-librair ie"
              >
                La Voix du Nord
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.munchiesart.club/top-art-instagram-accounts-you-have-to-follow/elize-sokolova-artist/"
              >
                Munchies Art Club
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
